<template>
  <table>
    <tbody>
      <tr>
        <td colspan="2">
          <small v-html="retrieveModalText('InfoText')"> </small>
        </td>
      </tr>
      <tr v-if="expectedProductionDate">
        <td class="label">{{ retrieveModalText('Production') }}</td>
        <td>
          <date-picker
            id="expectedProductionDate"
            :date="expectedProductionDate"
            title=""
            :disabled="true"
          />
        </td>
      </tr>
      <tr v-if="expectedDeliveryDateImporter">
        <td class="label">{{ retrieveModalText('Importer') }}</td>
        <td>
          <date-picker
            id="expectedDeliveryDateImporter"
            :date="expectedDeliveryDateImporter"
            title=""
            :disabled="true"
          />
        </td>
      </tr>
      <tr v-if="expectedDeliveryDateDealer">
        <td class="label">{{ retrieveModalText('Dealer') }}</td>
        <td>
          <date-picker
            id="expectedDeliveryDateDealer"
            :date="expectedDeliveryDateDealer"
            title=""
            :disabled="true"
          />
        </td>
      </tr>
      <tr v-if="expectedDeliveryDateCustomer">
        <td class="label">
          {{ retrieveModalText('Customer') }}
        </td>
        <td>
          <date-picker
            id="expectedDeliveryDateCustomer"
            :date="expectedDeliveryDateCustomer"
            title=""
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="label">{{ retrieveModalText('Delivery Date') }}</td>
        <td>
          <date-picker id="savedDeliveryDate" :date="deliveryDate" title="" :disabled="true" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import DatePicker from '@/components/generic/presentational/atoms/datePicker/DatePicker.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DatePicker,
  },
  props: {
    isPurchaseOrder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapState({
      expectedDeliveryDates(state, getters) {
        return getters[this.namespace + '/expectedDeliveryDates']
      },
      deliveryDate(state, getters) {
        return getters[this.namespace + '/deliveryDate']
      },
    }),
    namespace() {
      return this.isPurchaseOrder ? 'purchaseOrder' : 'quote'
    },
    expectedDeliveryDateCustomer() {
      return this.expectedDeliveryDates?.ExpectedDeliveryDateCustomer
    },
    expectedProductionDate() {
      return this.expectedDeliveryDates?.ExpectedProductionDate
    },
    expectedDeliveryDateImporter() {
      return this.expectedDeliveryDates?.ExpectedDeliveryDateImporter
    },
    expectedDeliveryDateDealer() {
      return this.expectedDeliveryDates?.ExpectedDeliveryDateDealer
    },
  },
  methods: {
    retrieveModalText(labelName) {
      return this.i18n.t(`/expected delivery date/${labelName}`)
    },
  },
}
</script>

<style lang="scss" scoped></style>
